<div class="flex justify-end w-full" *ngIf="index == 0">
  <div class="flex items-center gap-3">
    <div class="bg-amber-100 text-amber-800 px-4 py-2 rounded-md font-medium flex items-center gap-2 border border-amber-300">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
      OOTB Entity
    </div>
    <button
      class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[6px] px-[14px] cursor-pointer shadow-sm transition-all duration-300 font-medium flex items-center gap-2"
      (click)="exitToEntityList()"
    >
      <i class="fas fa-arrow-left text-sm"></i> Back To OOTB List
    </button>
  </div>
</div>

<div
  class="shadow-lg m-[10px] my-[20px] p-[20px] rounded-xl border-4 bg-gradient-to-br from-white to-amber-50 max-w-6xl mx-auto"
  [ngClass]="getColorClass(index)"
>
  <div class="flex justify-between items-center mb-6">
    <div class="text-indigo-900 font-medium flex items-center" *ngIf="hasValidId()">
      <div class="flex flex-col">
        <span class="text-xs uppercase tracking-wider text-indigo-400">Data Model</span>
        <span class="text-xl font-bold">{{ entityData.name }}</span>
      </div>
      <div class="ml-6 flex flex-col">
        <span class="text-xs uppercase tracking-wider text-indigo-400">Path</span>
        <span class="text-sm text-indigo-700">{{ modelName }}</span>
      </div>
    </div>
    <div class="flex items-center" *ngIf="!hasValidId()">
      <span class="text-gray-500 mr-2">Data Model Name:</span>
      <input
        class="rounded-lg border border-solid border-blue-200 h-[36px] bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent py-1 px-3 w-full text-[16px] transition-all duration-200"
        placeholder="Enter Table Name"
        [(ngModel)]="entityData.name"
        (keyup)="tableNameChanged()"
        pattern="\S+"
        title="Spaces are not allowed"
        autocomplete="off"
      />
    </div>
    <div
      *ngIf="status !== 'OOTB' && !isAdvancedAobContainer"
      class="relative group"
    >
      <button
        class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[8px] px-[16px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
        (click)="addVariableChangeFlag()"
      >
        <i class="fas fa-plus text-sm"></i> Add Variable
      </button>
    </div>
  </div>

  <div class="overflow-hidden rounded-lg bg-white shadow-md mb-6 border border-indigo-200">
    <div class="grid grid-cols-[600px_200px_200px] bg-gradient-to-r from-indigo-100 to-indigo-50 p-3 border-b border-indigo-100">
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-tag text-indigo-400"></i> Variable Name
      </div>
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-code text-indigo-400"></i> Type
      </div>
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-cog text-indigo-400"></i> Properties
      </div>
    </div>

    <div
      class="grid grid-cols-[600px_200px_200px_30px] hover:bg-indigo-50 transition-colors duration-150 border-b border-gray-100 relative group"
      *ngFor="let model of entityData.data; let i = index"
    >
      <div class="py-3 pl-3 cursor-pointer font-medium text-gray-700">
        {{ model.name }}
      </div>
      <div class="py-3 text-gray-700">
        <span class="px-2 py-1 rounded-md bg-indigo-50 text-indigo-700 text-sm">{{ model.type }}</span>
      </div>
      <div
        class="py-3"
        *ngIf="
          model.isUnique &&
          model.type !== 'AUTO_INCREMENT' &&
          model.type !== 'ARRAY_OF_STRING' &&
          model.type !== 'ARRAY_OF_NUMBER' &&
          model.type !== 'ARRAY_OF_OBJECT' &&
          model.type !== 'BOOLEAN' &&
          model.type !== 'TIMESTAMP' &&
          model.type !== 'GEOMETRY' &&
          model.type !== 'UUID' &&
          model.type !== 'ENTITY_REFERENCE'
        "
      >
        <span class="text-amber-600 bg-amber-50 px-2 py-1 rounded-full text-xs border border-amber-100">
          <i class="fas fa-fingerprint mr-1"></i> Unique
        </span>
      </div>
      <div
        class="py-3"
        *ngIf="
          !model.isUnique &&
          model.type !== 'AUTO_INCREMENT' &&
          model.type !== 'ARRAY_OF_STRING' &&
          model.type !== 'ARRAY_OF_NUMBER' &&
          model.type !== 'ARRAY_OF_OBJECT' &&
          model.type !== 'BOOLEAN' &&
          model.type !== 'TIMESTAMP' &&
          model.type !== 'GEOMETRY' &&
          model.type !== 'UUID' &&
          model.type !== 'ENTITY_REFERENCE'
        "
      ></div>
      <div
        class="py-3"
        *ngIf="model.type == 'UUID' && !model.primaryKey"
      ></div>
      <div
        class="py-3"
        *ngIf="model.type == 'UUID' && model.primaryKey"
      >
        <span class="text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full text-xs border border-indigo-100">
          <i class="fas fa-key mr-1"></i> Primary Key
        </span>
      </div>
      <div
        class="py-3"
        *ngIf="
          model.type == 'ARRAY_OF_STRING' ||
          model.type == 'ARRAY_OF_NUMBER' ||
          model.type == 'ARRAY_OF_OBJECT' ||
          model.type == 'BOOLEAN' ||
          model.type == 'TIMESTAMP'
        "
      ></div>
      <!-- Geometry: read-only summary, same glossary wording as the entity list cell. -->
      <div
        class="py-3"
        *ngIf="model.type == 'GEOMETRY'"
      >
        <span class="text-xs opacity-60 text-gray-700">{{ formatShapeSummary(model.defaultValue) }}</span>
      </div>
      <div
        class="py-3"
        *ngIf="model.type == 'ENTITY_REFERENCE'"
      >
        <div class="bg-blue-50 rounded-md p-2 text-xs border border-blue-100">
          <div class="text-blue-700"><i class="fas fa-link mr-1"></i> Entity: <span class="text-gray-700">{{ model.referenceEntityName }}</span></div>
          <div class="text-blue-700"><i class="fas fa-table mr-1"></i> Column: <span class="text-gray-700">{{ model.referenceEntityColumnName }}</span></div>
        </div>
      </div>
      <!-- <div
        class="py-3"
        *ngIf="model.type == 'SHARED_ENTITY_REFERENCE'"
      >
        <div class="bg-amber-50 rounded-md p-2 text-xs border border-amber-200">
          <div class="flex items-center gap-2 text-amber-700">
            <i class="fas fa-share-alt"></i>
            <span class="font-medium">{{ getEntityNameById(model.referenceEntityName) }}</span>
            <span class="text-amber-400">→</span>
            <span class="font-mono text-gray-700">{{ model.referenceEntityColumnName }}</span>
          </div>
        </div>
      </div> -->
      <div
        class="py-3"
        *ngIf="model.type == 'AUTO_INCREMENT'"
      >
        <div class="text-blue-700 text-sm">Starts From: <span class="text-gray-700">{{ model.startIncrementFrom }}</span></div>
      </div>
      <div
        *ngIf="
          editFlag &&
          model.name !== 'id' &&
          model.name !== 'id_auto_increment' &&
          model.name !== 'parent_id' &&
          checkDeleteFalgForObject(i)
        "
        class="w-[20px] h-full flex flex-col justify-center cursor-pointer group-hover:opacity-100 opacity-50 transition-opacity duration-200"
      >
        <div class="p-1 hover:bg-red-100 rounded-full transition-colors duration-150" (click)="deleteVariable(i)">
          <img src="assets/icons/delete-icon.svg" alt="Delete" class="hover:scale-110 transition-transform duration-150" />
        </div>
      </div>
      <div
        *ngIf="
          model.name !== 'id' &&
          model.name !== 'id_auto_increment' &&
          model.name !== 'parent_id' &&
          model.type !== 'ARRAY_OF_OBJECT'
        "
        class="w-[20px] h-full flex flex-col justify-center cursor-pointer group-hover:opacity-100 opacity-50 transition-opacity duration-200"
      >
        <div class="p-1 hover:bg-blue-100 rounded-full transition-colors duration-150" (click)="editVariable(i)">
          <img src="assets/icons/edit_icon.svg" alt="Edit" class="hover:scale-110 transition-transform duration-150" />
        </div>
      </div>
    </div>
  </div>
  <div class="" *ngFor="let data of entityData.data; let i = index">
    <span *ngIf="data.type == 'ARRAY_OF_OBJECT'" class="block border-l-4 border-amber-300 pl-4 mt-4">
      <app-ootb-entity
        [modelNameInput]="modelName"
        [(entityData)]="entityData.data[i]"
        [index]="index + 1"
        [editFlag]="editFlag"
      ></app-ootb-entity>
    </span>
  </div>
  <div class="flex justify-around mt-[60px]" *ngIf="index == 0">
    <div class="flex gap-4 flex-wrap justify-center">
      <div class="relative overflow-hidden group">
        <button
          class="bg-blue-600 hover:bg-blue-700 rounded-md text-white py-[10px] px-[24px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
          (click)="SaveTableChanges()"
        >
          <i class="fas fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="h-[100vh] w-[100vw] fixed z-[90] top-0 left-0 bg-indigo-900/30 backdrop-blur-[3px] transition-all duration-300"
  *ngIf="addVariableFlag"
>
  <div class="flex flex-col justify-center h-full">
    <div class="flex justify-center">
      <div
        class="relative w-[702px] bg-white rounded-xl px-[64px] py-[40px] shadow-2xl animate-modalSlide"
      >
        <div
          class="absolute top-[20px] right-[20px] cursor-pointer bg-indigo-100 p-2 rounded-full hover:bg-indigo-200 transition-all duration-300 transform hover:rotate-90"
          (click)="addVariableChangeFlag()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round" 
            stroke-linejoin="round"
            class="text-indigo-700"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        
        <div class="flex flex-col gap-[30px]">
          <div class="relative">
            <div class="text-[28px] font-medium text-center leading-[32px] text-indigo-900 mb-8">
              {{ editingVariableIndex !== null ? 'Edit Variable' : 'Add Variable' }}
            </div>
            <div class="absolute left-0 right-0 bottom-0 h-[3px] bg-gradient-to-r from-indigo-300 to-amber-300"></div>
          </div>
          
          <div class="flex gap-[40px] flex-wrap">
            <div class="min-w-[250px]">
              <div class="text-[16px] text-indigo-700 pb-[6px] flex items-center gap-2">
                <i class="fas fa-signature text-amber-500"></i> Variable Name
              </div>
              <div
                class="w-full h-[48px] border border-solid border-indigo-200 rounded-lg overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-indigo-400 focus-within:border-transparent shadow-sm"
              >
                <input
                  class="w-full h-full text-[15px] focus:outline-none px-4 py-2"
                  placeholder="Enter variable name"
                  [(ngModel)]="newVariableData.name"
                  (keyup)="variableNameChanged()"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
              </div>
            </div>
            
            <div class="min-w-[250px]">
              <div class="text-[16px] text-indigo-700 pb-[6px] flex items-center gap-2">
                <i class="fas fa-code text-amber-500"></i> Variable Type
              </div>
              <div class="w-full h-[48px] rounded-lg overflow-hidden">
                <div
                  class="w-full h-[48px] border border-solid border-indigo-200 rounded-lg overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-indigo-400 focus-within:border-transparent shadow-sm"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent px-4 py-2 text-[15px] appearance-none cursor-pointer"
                    [(ngModel)]="newVariableData.type"
                    (change)="newVariableTypeChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option class="hidden" value="">Select type</option>
                    <option class="p-[8px]" *ngFor="let type of dataTypes">
                      {{ type }}
                    </option>
                  </select>
                  <div class="absolute right-[24px] top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <i class="fas fa-chevron-down text-indigo-400"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Advanced is allowed ONLY on a top-level AOB (index === 0). A nested AOB cannot be advanced. -->
            <div class="min-w-[250px] flex items-end" *ngIf="newVariableData.type == 'ARRAY_OF_OBJECT' && index === 0">
              <label class="inline-flex items-center gap-3 cursor-pointer select-none">
                <input
                  type="checkbox"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-indigo-600 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 cursor-pointer transition-all duration-150"
                  [(ngModel)]="newVariableData.extendedAttributes"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <span class="text-[15px] text-indigo-700">Advanced</span>
              </label>
            </div>
          </div>

          <div class="flex gap-[20px] items-center" *ngIf="newVariableUniqueFlag">
            <div class="text-[16px] text-blue-700 pb-[4px]">Unique Key:</div>
            <div class="flex items-center gap-[20px]">
              <span class="flex items-center">
                <input
                  type="radio"
                  id="unique-yes"
                  name="uniqueKey"
                  [(ngModel)]="newVariableData.isUnique"
                  [value]="true"
                  class="mr-[8px] h-4 w-4 accent-blue-600"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <label for="unique-yes" class="text-[14px] text-gray-700"
                  >Yes</label
                >
              </span>
              <span class="flex items-center">
                <input
                  type="radio"
                  id="unique-no"
                  name="uniqueKey"
                  [(ngModel)]="newVariableData.isUnique"
                  [value]="false"
                  class="mr-[8px] h-4 w-4 accent-blue-600"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <label for="unique-no" class="text-[14px] text-gray-700"
                  >No</label
                >
              </span>
            </div>
          </div>
          <div
            class="flex gap-[20px] items-center"
            *ngIf="newVariableData.type == 'AUTO_INCREMENT'"
          >
            <div>
              <div class="text-[16px] text-blue-700 pb-[4px]">
                Increment Starts From
              </div>
              <div class="text-red-500 text-[12px]">* cannot be negative</div>
            </div>
            <div
              class="w-[100px] h-[40px] border border-solid border-blue-200 rounded-[8px] pl-[12px] overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
            >
              <input
                class="w-full h-full text-[14px] focus:outline-none"
                placeholder="Enter"
                type="number"
                min="0"
                [(ngModel)]="newVariableData.startIncrementFrom"
                (change)="newVaraibleStartIncementChange()"
                [disabled]="editingVariableIndex !== null && !editFlag"
                autocomplete="off"
              />
            </div>
          </div>
          <div
            class="flex gap-[32px]"
            *ngIf="newVariableData.type == 'ENTITY_REFERENCE'"
          >
            <div class="flex flex-col justify-center">
              <div
                class="text-[16px] text-red-500 pb-[4px]"
                *ngIf="referenceEntityOptions.length === 0"
              >
                No other data entities available
              </div>

              <div
                class="text-[16px] text-blue-700 pb-[4px]"
                *ngIf="referenceEntityOptions.length > 0"
              >
                Select Entity:
              </div>

              <div
                class="w-[271px] h-[40px] rounded-[8px] overflow-hidden"
                *ngIf="referenceEntityOptions.length > 0"
              >
                <div
                  class="w-[200px] h-[40px] border border-solid border-blue-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.referenceEntityName"
                    (change)="newVariableReferenceEntityChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option value="" disabled>Select</option>
                    <option
                      *ngFor="let e of referenceEntityOptions"
                      class="p-[4px]"
                      [value]="e.id"
                    >
                      {{ e.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- SHARED_ENTITY_REFERENCE Section -->
          <!-- <div
            class="flex flex-col gap-[16px]"
            *ngIf="newVariableData.type == 'SHARED_ENTITY_REFERENCE'"
          >
            <div class="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <div class="flex items-start gap-3">
                <i class="fas fa-info-circle text-amber-600 text-lg mt-0.5"></i>
                <div class="flex-1">
                  <div class="font-semibold text-amber-900 mb-2">Shared Entity Reference (SER)</div>
                  <ul class="text-sm text-amber-800 space-y-1.5 ml-4">
                    <li class="flex items-start"><span class="mr-2">•</span><span>Creates UUID column on this entity</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>Creates reverse reference column on target entity</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>You must manage associations manually in your code</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>Not auto-fetched in queries (requires explicit filtering)</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <div
                class="text-[16px] text-red-500 pb-[4px]"
                *ngIf="
                  !entityService.completeFinalizedEntityList.length ||
                  !(
                    (entityService.completeFinalizedEntityList.length == 1 &&
                      entityService.completeFinalizedEntityList[0].name !==
                        modelName) ||
                    entityService.completeFinalizedEntityList.length > 1
                  )
                "
              >
                No other data entities available
              </div>
              <div
                class="text-[16px] text-amber-700 pb-[4px] font-medium"
                *ngIf="
                  (entityService.completeFinalizedEntityList.length == 1 &&
                    entityService.completeFinalizedEntityList[0].name !==
                      modelName) ||
                  entityService.completeFinalizedEntityList.length > 1
                "
              >
                Target Entity:
              </div>
              <div
                class="w-[271px] h-[40px] rounded-[8px] overflow-hidden"
                *ngIf="
                  (entityService.completeFinalizedEntityList.length == 1 &&
                    entityService.completeFinalizedEntityList[0].name !==
                      modelName) ||
                  entityService.completeFinalizedEntityList.length > 1
                "
              >
                <div
                  class="w-full h-[40px] border border-solid border-amber-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-amber-400 focus-within:border-transparent"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.referenceEntityName"
                    (change)="serTargetEntityChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option value="" disabled>Select target entity</option>
                    <ng-container
                      *ngFor="
                        let entityListFinalized of entityService.completeFinalizedEntityList
                      "
                    >
                      <option 
                        *ngIf="entityListFinalized.name !== modelName" 
                        class="p-[4px]" 
                        [value]="entityListFinalized.id"
                      >
                        {{ entityListFinalized.name }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="newVariableData.referenceEntityName">
              <div class="text-[16px] text-amber-700 pb-[4px] font-medium">
                Column Name on Target Entity (will be created):
              </div>
              <div class="w-[271px] h-[40px] border border-solid border-amber-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-amber-400 focus-within:border-transparent">
                <input
                  class="focus:outline-none h-full w-full bg-transparent"
                  type="text"
                  [(ngModel)]="newVariableData.referenceEntityColumnName"
                  (input)="serReverseColumnNameChanged()"
                  placeholder="e.g., parent_ids, invoice_ids"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
              </div>
              <div class="text-xs text-amber-600 mt-2 ml-1">
                <i class="fas fa-arrow-right mr-1"></i>
                Will create UUID column "{{ newVariableData.referenceEntityColumnName || '(name)' }}" on <strong>{{ getTargetEntityName() }}</strong>
              </div>
            </div>
          </div> -->

          <div class="flex gap-[20px] mb-[30px] items-center" *ngIf="newVariableData.type == 'STRING' || newVariableData.type == 'NUMBER' || newVariableData.type == 'BOOLEAN'">
            <div class="text-[16px] text-blue-700 pb-[4px]">
                Default Value:
            </div>
            <div
              class="flex gap-[30px] h-[40px] rounded-[8px] overflow-hidden"
            >
              <div
                *ngIf="newVariableData.type == 'BOOLEAN'"
                class="w-[170px] h-[40px] border border-solid border-blue-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
              >
                <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.defaultValue"
                  >
                    <option class="p-[4px]" *ngFor="let opt of booleanOptions" [ngValue]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>

              </div>
              <app-default-value-editor
                [type]="newVariableData.type"
                [value]="newVariableData.defaultValue"
                (valueChange)="newVariableData.defaultValue = $event"
                inputClass="focus:outline-none h-[40px] w-[170px] bg-transparent border border-solid border-blue-200 rounded-[8px] text-[14px] px-[12px] disabled:opacity-40"
              ></app-default-value-editor>
            </div>
          </div>
          <div class="flex justify-around mt-6">
            <button
              class="bg-indigo-600 hover:bg-indigo-700 px-8 py-3 rounded-md text-white text-[16px] shadow-sm transition-all duration-300 flex items-center gap-2"
              (click)="editingVariableIndex !== null ? updateVariable() : addVariable()"
              *ngIf="addVariableButtonFlag"
            >
              <i class="fas fa-{{ editingVariableIndex !== null ? 'sync-alt' : 'plus-circle' }}"></i>
              {{ editingVariableIndex !== null ? 'Update Variable' : 'Add Variable' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="h-[100vh] w-[100vw] fixed z-[90] top-0 left-0 bg-red-900/30 backdrop-blur-[3px] transition-all duration-300"
  *ngIf="showExitWarning"
>
  <div class="flex flex-col justify-center h-full">
    <div class="flex justify-center">
      <div
        class="relative w-[400px] bg-white rounded-xl px-[32px] py-[28px] shadow-2xl animate-warningPulse"
      >
        <div class="text-[22px] font-bold text-center leading-[24px] text-red-600 mb-2 flex justify-center items-center gap-3">
          <div class="bg-red-100 p-3 rounded-full">
            <i class="fas fa-exclamation-triangle text-xl"></i>
          </div>
          <span>Unsaved Changes</span>
        </div>
        <div class="text-[15px] text-center mt-[16px] text-gray-700">
          You have unsaved changes that will be lost if you leave. Do you want to proceed?
        </div>
        <div class="flex justify-center gap-6 mt-[32px]">
          <button
            class="bg-white border border-red-500 text-red-600 py-[8px] px-[20px] rounded-md hover:bg-red-50 transition-all duration-200 flex items-center gap-2"
            (click)="confirmExit()"
          >
            <i class="fas fa-sign-out-alt"></i> Leave
          </button>
          <button
            class="bg-indigo-600 hover:bg-indigo-700 text-white py-[8px] px-[20px] rounded-md shadow-sm transition-all duration-300 flex items-center gap-2"
            (click)="cancelExit($event)"
          >
            <i class="fas fa-save"></i> Stay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes modalSlide {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes warningPulse {
    0% { transform: scale(0.95); opacity: 0; }
    70% { transform: scale(1.02); }
    100% { transform: scale(1); opacity: 1; }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-out forwards;
  }
  
  .animate-modalSlide {
    animation: modalSlide 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  
  .animate-warningPulse {
    animation: warningPulse 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #a5b4fc;
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #818cf8;
  }
  
  select {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%234f46e5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
  }
</style>